import { useTranslation } from 'react-i18next';
import { Quote, Star } from 'lucide-react';
import { SectionWrapper } from '@/components/common';

interface TestimonialCardProps {
  text?: string;
  name?: string;
  location?: string;
  rating?: number;
  serviceType?: string;
  color?: string;
  bgColor?: string;
  className?: string;
}

export function TestimonialCard({
  text,
  name,
  location,
  rating = 5,
  serviceType,
  color = 'text-blue-600',
  bgColor = 'bg-blue-600',
  className,
}: TestimonialCardProps) {
  const { t } = useTranslation('services');

  const displayText = text || (serviceType ? t(`${serviceType}.testimonial.text`) : '');
  const displayName = name || (serviceType ? t(`${serviceType}.testimonial.name`) : '');
  const displayLocation = location || (serviceType ? t(`${serviceType}.testimonial.location`) : '');

  return (
    <SectionWrapper bgColor="bg-white" maxWidth="4xl" className={className}>
      <div className="relative bg-gray-50 rounded-3xl p-8 md:p-12">
        <Quote className={`w-12 h-12 ${color} opacity-20 absolute top-8 right-8`} />
        <div className="flex items-center gap-1 mb-6">
          {[...Array(rating)].map((_, i) => (
            <Star key={i} className="w-6 h-6 text-yellow-400 fill-current" />
          ))}
        </div>
        <p className="text-xl lg:text-2xl text-gray-700 mb-8 leading-relaxed">
          "{displayText}"
        </p>
        <div className="flex items-center gap-4">
          <div className={`w-14 h-14 ${bgColor} rounded-full flex items-center justify-center`}>
            <span className="text-xl font-bold text-white">
              {displayName.charAt(0)}
            </span>
          </div>
          <div>
            <div className="font-semibold text-gray-900">
              {displayName}
            </div>
            <div className="text-gray-500">
              {displayLocation}
            </div>
          </div>
        </div>
      </div>
    </SectionWrapper>
  );
}
